import { erpAxios } from '..';

const deleteDokument = async (id) => {
  const res = await erpAxios.delete(`/dokumenti/${id}`);
  return res;
};

export default deleteDokument;
